export const sources = {
  ehubt: {
    id: 'constraints-ehubt',
    type: 'vector',
    pmtilesFile: 'EHUBt.pmtiles',
  },
  statSector: {
    id: 'constraints-stat-sector',
    type: 'vector',
    pmtilesFile: 'Stat_sector.pmtiles',
  },
  obstruction: {
    id: 'constraints-obstruction',
    type: 'vector',
    pmtilesFile: 'Obstructielagen.pmtiles',
  },
};

export const layerColors = {
  ehubt: ['#fff', '#E8D8F1', '#D0A9E3', '#A66BC2', '#6A1B9A'],
  warmtevraag: ['#fff', '#F1C9C9', '#E58C8C', '#CF4F4F', '#B51F2A'],
};

function getScoreColorExpression(property, colors) {
  return [
    'step',
    ['coalesce', ['get', property], 0],
    colors[0],
    1,
    colors[1],
    2,
    colors[2],
    3,
    colors[3],
    4,
    colors[4],
  ];
}

export const layers = {
  ehubt: {
    'id': 'constraints-ehubt',
    'type': 'fill',
    'source': sources.ehubt.id,
    'source-layer': 'EHUBt',
    'paint': {
      'fill-color': getScoreColorExpression('EHUBt_score', layerColors.ehubt),
      'fill-opacity': 0.8,
      'fill-outline-color': '#fff',
    },
  },
  hoveredEhubt: {
    'id': 'constraints-ehubt-hover-outline',
    'type': 'line',
    'source': sources.ehubt.id,
    'source-layer': 'EHUBt',
    'paint': {
      'line-color': '#A8D5DE',
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2,
        0,
      ],
    },
  },
  warmtevraag: {
    'id': 'constraints-warmtevraag',
    'type': 'fill',
    'source': sources.statSector.id,
    'source-layer': 'Stat_sector',
    'paint': {
      'fill-color': getScoreColorExpression('warmtevraag_score', layerColors.warmtevraag),
      'fill-opacity': 0.8,
      'fill-outline-color': '#fff',
    },
  },
  hoveredWarmtevraag: {
    'id': 'constraints-warmtevraag-hover-outline',
    'type': 'line',
    'source': sources.statSector.id,
    'source-layer': 'Stat_sector',
    'paint': {
      'line-color': '#A8D5DE',
      'line-width': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        2,
        0,
      ],
    },
  },
  obstructionPolygon: {
    'id': 'constraints-obstruction-polygon',
    'type': 'fill',
    'source': sources.obstruction.id,
    'source-layer': 'Obstructielagen',
    'paint': {
      'fill-color': '#666',
      'fill-opacity': 0.45,
      'fill-outline-color': '#fff',
    },
  },
  obstructionLine: {
    'id': 'constraints-obstruction-line',
    'type': 'line',
    'source': sources.obstruction.id,
    'source-layer': 'Obstructielagen',
    'layout': {
      'line-cap': 'round',
    },
    'paint': {
      'line-color': '#000',
      'line-dasharray': [1, 4],
      'line-width': 2,
    },
  },
};
